<svg style="width: {{ size }}; height: {{ size }}" *ngIf="!html"></svg>
<svg *ngIf="html" [outerHTML]="html"></svg>
